import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-step1',
  standalone: true,
  imports: [],
  templateUrl: './step1.component.html',
  styleUrl: './step1.component.scss'
})
export class Step1Component {
  @Input() logo: string = '';
  @Input() welcomeText: string = 'Presiona la pantalla para comenzar';
}
